import {MediaQuery} from '@constants/theme';
import {Theme} from '@emotion/react';
import {SxProps} from '@mui/material';

const checkButtonStyle = {
  'padding': '4px 16px',
  'gap': '12px',
  'borderRadius': '100px',
  'fontSize': '15px',
  'fontWeight': 400,
  'lineHeight': '22.5px',
  'letterSpacing': '-0.4000000059604645px',
  'flex': 1,
  'display': 'flex',
  'alignItems': 'center',
  'justifyContent': 'center',
  'color': 'rgba(45, 45, 45, 1)',
  'cursor': 'pointer',
  'minHeight': '34px',
  '&:hover': {
    background: 'rgba(237, 236, 232, .8)',
  },
};

const styles: Record<string, SxProps<Theme>> = {
  checkButtonWrapper: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '4px',
    borderRadius: '100px',
    border: '1px solid #82807EB2',
    overflowX: 'auto',
    [MediaQuery.desktop]: {},

      /* Hide scrollbar for Webkit-based browsers */
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  /* For Firefox */
  scrollbarWidth: 'none', /* Disables scrollbar */
  msOverflowStyle: 'none', /* For Internet Explorer and Edge */
    
  },
  checkButton:{
    textTransform: 'capitalize',
    '&.MuiToggleButton-root':{
      'padding': '4px 16px',
      'gap': '12px',
      'borderRadius': '100px !important',
      'fontSize': '15px',
      'fontWeight': 400,
      'lineHeight': '22.5px',
      'letterSpacing': '-0.4000000059604645px',
      'flex': 1,
      'display': 'flex',
      'alignItems': 'center',
      'justifyContent': 'center',
      'color': 'rgba(45, 45, 45, 1)',
      'cursor': 'pointer',
      'minHeight': '34px',
      background:'transparent',
      border:'none !important',
    },

    '&.Mui-selected':{
      background: 'rgba(237, 236, 232, 1)'
    }
  } ,
};

export default styles;
